module.exports = __webpack_public_path__ + "img/Lei-li-formal-320w.ef9108b.jpeg";